"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _RichText = _interopRequireDefault(require("../RichText"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    textWrapper: {
      wordBreak: 'break-word',
      margin: theme.spacing(0),
      marginBottom: theme.spacing(10),
      '& h2': {
        marginBottom: theme.spacing(2, '!important'),
        paddingBottom: theme.spacing(0, '!important')
      }
    }
  };
});
var TextEditConfig = {
  emptyLabel: 'Text',
  isEmpty: function isEmpty(props) {
    return !props || !props.text || props.text.trim().length < 1;
  }
};
var Text = function Text(_ref) {
  var text = _ref.text,
    _ref$richText = _ref.richText,
    richText = _ref$richText === void 0 ? true : _ref$richText;
  var classes = useStyles();
  if (!text) return null;
  return __jsx(_core.Typography, {
    component: "div",
    className: "aem-ms-text-cmp ".concat(classes.textWrapper)
  }, __jsx(_RichText.default, {
    text: text
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/text')(Text, TextEditConfig);
exports.default = _default;